import PropTypes from "prop-types";

export default {
	label: PropTypes.string,
	isVisible: PropTypes.bool,
};
